import { Component, OnInit } from '@angular/core';
import { AlertService, ResourceService } from '../../_services/index';
import { Resource } from '../../_models/index';
import * as GlobalVariables from '../globals/globals';
import * as $ from 'jquery';

@Component({
  selector: 'app-resource-quest',
  templateUrl: './resource-quest.component.html',
  styleUrls: ['./resource-quest.component.css']
})
export class ResourceQuestComponent implements OnInit {
  lang = 1;
  searchText = '';
  loading = false;
  resources: Resource[] = [];
  filteredResources: Resource[] = [];
  isAdminUser = false;
  // Current sort option: 'default' keeps display order
  sortOption: string = 'default';

  // Translation object for UI text
  translations = {
    title: {
      1: 'Resources Library',
      2: 'Bibliothèque de ressources',
      3: 'Biblioteca de recursos',
      4: 'Biblioteca de Recursos',
      5: '리소스 라이브러리',
      6: 'مكتبة الموارد'
    },
    subtitle: {
      1: 'Explore resources and literature curated for SDG 6 targets and indicators.',
      2: 'Explorez les ressources et la littérature organisées pour les cibles et indicateurs de l\'ODD 6.',
      3: 'Explore recursos y literatura seleccionados para metas e indicadores del ODS 6.',
      4: 'Explore recursos e literatura selecionados para metas e indicadores do ODS 6.',
      5: 'SDG 6 목표 및 지표를 위해 선별된 리소스와 문헌을 탐색하세요.',
      6: 'استكشف الموارد والمراجع المنسقة لأهداف وغايات الهدف السادس من أهداف التنمية المستدامة.'
    },
    searchPlaceholder: {
      1: 'Search resources by title, year, or link...',
      2: 'Rechercher des ressources par titre, année ou lien...',
      3: 'Buscar recursos por título, año o enlace...',
      4: 'Pesquisar recursos por título, ano ou link...',
      5: '제목, 연도 또는 링크로 리소스 검색...',
      6: 'ابحث عن الموارد حسب العنوان أو السنة أو الرابط...'
    },
    noResults: {
      1: 'No resources found.',
      2: 'Aucune ressource trouvée.',
      3: 'No se encontraron recursos.',
      4: 'Nenhum recurso encontrado.',
      5: '리소스를 찾을 수 없습니다.',
      6: 'لم يتم العثور على موارد.'
    },
    clearSearch: {
      1: 'Clear Search',
      2: 'Effacer la recherche',
      3: 'Borrar búsqueda',
      4: 'Limpar pesquisa',
      5: '검색 지우기',
      6: 'مسح البحث'
    },
    year: {
      1: 'Year',
      2: 'Année',
      3: 'Año',
      4: 'Ano',
      5: '연도',
      6: 'السنة'
    },
    link: {
      1: 'Link',
      2: 'Lien',
      3: 'Enlace',
      4: 'Link',
      5: '링크',
      6: 'الرابط'
    },
    openResource: {
      1: 'Open resource',
      2: 'Ouvrir la ressource',
      3: 'Abrir recurso',
      4: 'Abrir recurso',
      5: '리소스 열기',
      6: 'فتح المورد'
    },
    loadingResources: {
      1: 'Loading resources...',
      2: 'Chargement des ressources...',
      3: 'Cargando recursos...',
      4: 'Carregando recursos...',
      5: '리소스 불러오는 중...',
      6: 'جاري تحميل الموارد...'
    },
    footerInfo: {
      1: 'Resources are managed from Django Admin and shown here in display order.',
      2: 'Les ressources sont gérées dans l\'administration Django et affichées ici selon l\'ordre défini.',
      3: 'Los recursos se gestionan desde Django Admin y se muestran aquí según el orden de visualización.',
      4: 'Os recursos são gerenciados no Django Admin e exibidos aqui na ordem de exibição.',
      5: '리소스는 Django Admin에서 관리되며 표시 순서대로 여기에 표시됩니다.',
      6: 'تتم إدارة الموارد من Django Admin ويتم عرضها هنا حسب ترتيب العرض.'
    }
  };

  constructor(
    private resourceService: ResourceService,
    private alertService: AlertService
  ) { }

  ngOnInit() {
    $('.header_active').removeClass('header_active');
    $('.resource-click').addClass('header_active');

    // Initialize language based on current URL
    this.lang = GlobalVariables.findTranslationOptionsIndex(window);
    const currentUserId = localStorage.getItem('currentUserId');
    if (currentUserId) {
      this.isAdminUser = JSON.parse(currentUserId).role === 1;
    }
    this.loadResources();
  }

  private loadResources() {
    this.loading = true;
    this.resourceService.getAll().subscribe(
      data => {
        // Filter resources to only show those with content in current language
        const filteredData = (data || []).filter(r => this.hasLanguageContent(r, this.lang));
        this.resources = filteredData.slice().sort((a, b) => {
          const left = (a.order || 0);
          const right = (b.order || 0);
          if (left !== right) {
            return left - right;
          }
          return (a.id || 0) - (b.id || 0);
        });
        this.filteredResources = [...this.resources];
        // Apply any active sort (default keeps display order)
        this.sortResources();
        this.loading = false;
      },
      error => {
        this.loading = false;
        this.alertService.error(error);
      }
    );
  }

  private hasLanguageContent(resource: Resource, lang: number): boolean {
    // Check if resource has name or label for the current language
    const nameField = lang === 1 ? 'name' : 'name_' + ['', 'fr', 'es', 'pt', 'ko', 'ar'][lang - 1];
    const labelField = 'label_' + ['en', 'fr', 'es', 'pt', 'ko', 'ar'][lang - 1];
    
    const name = (resource as any)[nameField];
    const label = (resource as any)[labelField];
    
    return !!(name && name.trim()) || !!(label && label.trim());
  }

  // Helper method to get translated text
  getTranslation(key: string): string {
    return this.translations[key][this.lang] || this.translations[key][1];
  }

  searchResources() {
    const query = (this.searchText || '').trim().toLowerCase();
    if (!query) {
      this.filteredResources = [...this.resources];
      this.sortResources();
      return;
    }

    this.filteredResources = this.resources.filter(resource => {
      const name = this.getResourceName(resource).toLowerCase();
      const link = (this.getResourceLink(resource) || '').toLowerCase();
      const year = (resource.year || '').toLowerCase();
      return name.indexOf(query) > -1 || link.indexOf(query) > -1 || year.indexOf(query) > -1;
    });
    // Apply current sort to the filtered results
    this.sortResources();
  }

  clearSearch() {
    this.searchText = '';
    this.filteredResources = [...this.resources];
    this.sortResources();
  }

  // Sort currently displayed resources according to `sortOption`.
  sortResources() {
    if (!this.filteredResources) {
      return;
    }

    const list = [...this.filteredResources];
    switch (this.sortOption) {
      case 'title_asc':
        this.filteredResources = list.sort((a, b) => this.getResourceName(a).localeCompare(this.getResourceName(b)));
        break;
      case 'title_desc':
        this.filteredResources = list.sort((a, b) => this.getResourceName(b).localeCompare(this.getResourceName(a)));
        break;
      case 'newest':
        this.filteredResources = list.sort((a, b) => (b.id || 0) - (a.id || 0));
        break;
      case 'oldest':
        this.filteredResources = list.sort((a, b) => (a.id || 0) - (b.id || 0));
        break;
      default:
        // 'default' or unknown: keep original display order (resources order)
        this.filteredResources = [...this.resources].filter(r => list.find(x => x.id === r.id));
        break;
    }
  }

  getResourceName(resource: Resource): string {
    // Only use name fields for heading
    return this.getLocalizedValue(resource, 'name') || '-';
  }

  getResourceLink(resource: Resource): string {
    return resource.resources_link || '';
  }

  getExternalLink(resource: Resource): string {
    const link = this.getResourceLink(resource).trim();
    if (!link) {
      return '';
    }
    if (link.startsWith('http://') || link.startsWith('https://')) {
      return link;
    }
    return 'https://' + link;
  }

  getResourceLinkText(resource: Resource): string {
    // First check for label in current language
    const label = this.getLocalizedValue(resource, 'label').trim();
    if (label) {
      return label;
    }
    // If no label, show truncated link
    const link = this.getResourceLink(resource);
    if (link) {
      return this.truncateLink(link);
    }
    return '';
  }

  private truncateLink(link: string, maxLength: number = 30): string {
    if (link.length <= maxLength) {
      return link;
    }
    return link.substring(0, maxLength) + '...';
  }

  private getLocalizedValue(resource: Resource, fieldName: string): string {
    // Different suffix logic for name vs label fields
    // Names: name, name_fr, name_es... (no suffix for English)
    // Labels: label_en, label_fr, label_es... (_en suffix for English)
    let langSuffix: string;
    if (fieldName === 'name') {
      langSuffix = ['', '_fr', '_es', '_pt', '_ko', '_ar'][this.lang - 1];
    } else {
      langSuffix = ['_en', '_fr', '_es', '_pt', '_ko', '_ar'][this.lang - 1];
    }

    const preferredField = fieldName + langSuffix;
    const preferredValue = (resource as any)[preferredField];
    if (preferredValue && preferredValue.trim() !== '') {
      return preferredValue;
    }
    // Language-specific, no fallback
    return '';
  }
}



// WEBPACK FOOTER //
// ./src/app/sdg/resource-quest/resource-quest.component.ts